import { Component, OnInit } from '@angular/core';
import { userType } from 'src/app/constants/global-constants';
import { IFetchRoomResponse, IRoomDetails } from 'src/app/models/dashboard.models';
import { AuthService } from 'src/app/services/auth.service';
import { ChatService } from 'src/app/services/chat.service';

@Component({
  selector: 'app-chats',
  templateUrl: './chats.component.html',
  styleUrls: ['./chats.component.scss']
})
export class ChatsComponent implements OnInit {

  chatList: Array<IRoomDetails> = [];
  userType = userType;
  loading: boolean = true;

  constructor(public authService: AuthService, public chatService: ChatService) { }

  ngOnInit(): void {
    this.getChatList();
  }

  getChatList(){
    this.chatService.fetchChatRooms()
    .subscribe((res: IFetchRoomResponse)=>{
      this.chatList = res.payload;
      this.loading = false;
      console.log("Chat List:", this.chatList);
      this.fetchLastMessages();
    },err=>{
      console.error("Chat List Error:", err);
    });
  }

  fetchLastMessages(){
    this.chatList.forEach(chat => {
      this.chatService.getLastMessage(chat.roomId).subscribe(res=>{
        if(res.length){
          chat.lastMessage = res[0].message;
          chat.timestamp = new Date(res[0].timestamp);
        }
      });
    });
  }

}
